import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-92d63ff2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-w-full tw-h-full tw-relative tw-overflow-x-hidden p-main md:tw-py-[0px] main" }
const _hoisted_2 = { class: "title tw-text-[22px]" }
const _hoisted_3 = { class: "tw-text-[#211F58] tw-text-[15px] tw-not-italic tw-font-normal tw-leading-[145%]" }
const _hoisted_4 = { class: "body-container tw-flex tw-flex-col md:tw-flex-row tw-gap-[40px] md:tw-gap-[80px] tw-flex-wrap" }
const _hoisted_5 = { class: "table-content" }
const _hoisted_6 = { class: "tw-flex tw-flex-col tw-gap-[20px]" }
const _hoisted_7 = { class: "tw-flex tw-flex-col md:tw-flex-row tw-items-start tw-gap-[20px] tw-justify-between tw-flex-wrap" }
const _hoisted_8 = { class: "tw-text-[#211F58] !tw-text-[18px] tw-not-italic tw-font-semibold tw-leading-[normal.] sub-title tw-text-lg" }
const _hoisted_9 = { class: "tw-not-italic tw-font-normal tw-leading-[normal] tw-text-[18px]" }
const _hoisted_10 = { class: "group-button tw-flex tw-items-center tw-justify-end" }
const _hoisted_11 = { class: "tw-flex tw-flex-col tw-gap-[20px] tw-mt-[40px]" }
const _hoisted_12 = { class: "table-header tw-flex tw-flex-col md:tw-flex-row tw-items-start tw-gap-[20px] md:tw-items-center tw-justify-between tw-flex-wrap" }
const _hoisted_13 = { class: "tw-text-[#211F58] !tw-text-[18px] tw-not-italic tw-font-semibold tw-leading-[normal.] sub-title tw-text-lg tw-font-semibold" }
const _hoisted_14 = { class: "tw-not-italic tw-font-normal tw-leading-[normal] tw-text-[18px]" }
const _hoisted_15 = { class: "group-button tw-flex tw-items-center tw-justify-end" }
const _hoisted_16 = { class: "action-button-container tw-order-[1] md:tw-order-[2] tw-w-[100%] tw-flex tw-justify-center tw-rounded-br-md tw-rounded-bl-md tw-h-[fit-content] actionsWrapper tw-max-w-[241px] lg:tw-min-w-[241px]" }
const _hoisted_17 = { class: "tw-m-0" }
const _hoisted_18 = { class: "tw-text-[12px]" }
const _hoisted_19 = { class: "tw-m-0" }

import {
  ref,
  onMounted,
  Ref,
  watch,
  onBeforeMount,
  computed,
  onUnmounted,
} from "vue";

import AppBarLayout from "@/components/layouts/appBarLayout.vue";
import IconButton from "@/components/common/iconButton.vue";
import ButtonFilter from "@/components/common/setting/buttonFilter.vue";
import ButtonBulkActions from "@/components/common/setting/buttonBulkActions.vue";
import { getComponentUiText } from "@/utils/utilities";
import NoteInfo from "@/components/common/noteInfo.vue";
import CustomTable, {
  CustomTableColumn,
} from "@/components/common/customTable.vue";
import ActionButton, { Action } from "@/components/common/actionButton.vue";
import BrandPattern from "@/components/prospect/brandPattern/brandPattern4.vue";
import BackgroundComponent from "@/components/common/backgroundComponent.vue";
import ActivePathWrapper from "@/components/common/activePathWrapper.vue";
import Tooltip from "@/components/common/tooltip.vue";
import StatusBadge from "@/components/common/setting/statusBadge.vue";
import VRuntimeTemplate from "vue3-runtime-template";
import CreateOrgModal from "@/components/orgManagement/createOrgModal.vue";
import {
  ModalTypes,
  routers,
  statusCode,
  actionClickType,
  MODAL_NAME,
  requestAccessDetailModalType,
  ORG_TO_ORG_TYPE_CORLOR,
} from "@/utils/constants";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import OfferAccessModal from "@/components/orgManagement/offerAccessModal.vue";
import RequestAccessDetailModal from "@/components/orgManagement/requestAccessDetailModal.vue";
import store from "@/store";
import {
  deleteAccessGrant,
  getOrgAccessGrantedByCurrent,
  getOrgAccessGrantedByOther,
  deleteOrgAccessGrants,
  getAccessRequest,
  getAccessOffer,
  fetchOrgAccessType,
  fetchInvalidDomains,
} from "@/services/org";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import utilities from "@/utils/utilities";
import router from "@/router";
import CellTableAction from "@/components/common/setting/cellTableAction.vue";
import ManageUserModal from "@/components/orgManagement/manageUserModal.vue";
import AddIcon from "@/components/svgs/addIcon.vue";
import UserIcon from "@/components/svgs/userIcon.vue";
import { useRoute } from "vue-router";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import CustomDropDownItem from "@/components/common/customDropDownItem.vue";
import { IModalMessage } from "@/interfaces/common/common";
import { IOrgAccessType } from "@/interfaces/orgInterfaces";


export default /*#__PURE__*/_defineComponent({
  __name: 'manageAccess',
  setup(__props) {

const notInfoVisible = ref(true);
const showTooltip = ref(false);
const createdUserName = ref(null);
const accessibleBySelectedRows = ref<number[]>([]);
const accessToSelectedRows = ref<number[]>([]);
const email = ref("");
const animationRef: Ref<typeof BrandPattern | null> = ref(null);
const clickboxAccessRef: Ref<HTMLElement | null> = ref(null);

let showModalRemoveOrgAccess = ref(false);
const modal = ref(null) as Ref<ModalTypes | null>;
const selectedSingleOrg: any = {};
const isAssessBy: Ref<boolean> = ref(false);
const isMultipleSelect: Ref<boolean> = ref(false);
const accessibleByTableData: Ref<Array<any>> = ref([]);
const orgsWithAccessToTableData: Ref<Array<any>> = ref([]);
const showModalOffer: Ref<boolean> = ref(false);
const showModalRequest: Ref<boolean> = ref(false);
const isLoadingAccessibleByTableData: Ref<boolean> = ref(true);
const isLoadingOrgsWithAccessToTableData: Ref<boolean> = ref(true);

const currentOrg = computed(() => store.state.Org.currentOrg);
const isLoading = computed(() => store.state.Org.isLoadingOrg);
const setModal = (val) => {
  modal.value = val;
  history.state.modal = val;
};

const addOfferAccess = () => {
  showModalOffer.value = true;
};

const addRequestAccess = () => {
  showModalRequest.value = true;
};

const updateStatus = (item: Record<string, any>) => {
  showTooltip.value = true;
  email.value = item.orgOwner?.email || ("" as string);
};

const updateAccessibleBySelectedRows = (selectedRows: number[]) => {
  accessibleBySelectedRows.value = selectedRows;
  if (accessibleBySelectedRows.value.length < 1) {
    isShowMoreActions.value = false;
  }
};

const updateAccessToSelectedRows = (selectedRows: number[]) => {
  accessToSelectedRows.value = selectedRows;
  if (accessToSelectedRows.value.length < 1) {
    isShowMoreActionsOrg.value = false;
  }
};

const profileActions: Action[] = [
  {
    icon: AddIcon,
    title: "app-settings-organisation-manage-access-create-new-org-1",
    titleClass: "tw-max-w-[149px]",
    onClick: () => setModal(ModalTypes.CreateOrg),
  },
  {
    icon: UserIcon,
    title: "app-settings-organisation-manage-access-manage-members-1",
    titleClass: "tw-w-[149px]",
    onClick: () => handleClickActionButton(routers.settingTeamMembers),
  },
];

const getOfferActions = (item: Record<string, any>) => {
  if (item.status === statusCode.pending) {
    return [actionClickType.actionProcessOffer];
  }
  return [actionClickType.actionRemoveOrgAccess];
};

const getRequestActions = (item: Record<string, any>) => {
  if (item.status === statusCode.pending) {
    return [actionClickType.actionProcessRequest];
  }
  return [actionClickType.actionRemoveOrgAccess];
};

const accessibleByTableColumns: CustomTableColumn[] = [
  {
    text: getComponentUiText("app-component-custom-table-header-name-1"),
    value: "name",
    headerClass:
      "tw-text-[#211F58] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    render: (value: string) =>
      `<span class="tw-min-w-[180px] tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[normal]">${
        value.charAt(0).toUpperCase() + value.slice(1)
      }</span>`,
    sortable: true,
    sortDefault: true,
  },
  {
    text: getComponentUiText(
      "app-settings-organisation-manage-access-table-header-org-type-1",
    ),
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    render: (value: string) =>
      `<span class="!tw-w-[200px]"><span style="border:1px solid ${
        ORG_TO_ORG_TYPE_CORLOR[value]
          ? ORG_TO_ORG_TYPE_CORLOR[value].border
          : ORG_TO_ORG_TYPE_CORLOR.don.border
      } " class='tw-text-[${
        ORG_TO_ORG_TYPE_CORLOR[value]
          ? ORG_TO_ORG_TYPE_CORLOR[value].text
          : ORG_TO_ORG_TYPE_CORLOR.don.text
      }] tw-px-[5px] tw-py-[3px] tw-rounded-[4px] !tw-text-[11px] !tw-not-italic !tw-font-medium !tw-leading-[130%] ${
        value === "Beneficiary" ? "benefica-text" : ""
      }'>${getAccessType(value)}</span></span>`,
    value: "orgType",
  },
  {
    text: getComponentUiText(
      "app-settings-organisation-manage-access-table-header-org-owner-1",
    ),
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    value: "orgOwner",
    render: (value: any) =>
      `<span class="tw-flex tw-flex-col">
      <span class="tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-normal">${value.name}</span>
      <div class="box-email ${value.email.length > 40 ? 'long-email' : ''}">
        <div class="tooltip-arrow"></div>
        <div class="box-tooltip"> 
          <span class="tw-text-[#211F58] tw-text-[11px] tw-not-italic tw-font-medium tw-leading-[100%]">${value.email}</span> 
        </div>
        <div class="tw-text-[#878787] tw-text-xs tw-not-italic tw-font-normal tw-leading-[100%] tw-text-[12px] text-ellipsis" id="email-col">${value.email}</div>
      </div>
      </span>`,
  },
  {
    text: getComponentUiText(
      "app-settings-organisation-manage-access-table-header-lock-status-1",
    ),
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    value: "*",
    render: (row: any) =>
      `<span class="tw-flex tw-items-center tw-gap-[5px] tw-w-[130px]"> ${
        row.lockStatus
          ? `<img class="tw-h-[14px] tw-w-[14px]" src=${
              row.disabled ? "/img/lock1_grey_icon.svg" : "/img/lock1_icon.svg"
            } alt="icon" />`
          : ""
      } <span class="${
        row.disabled ? "tw-text-[#B7B7B7]" : "tw-text-[#231F20]"
      } tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[normal]">${
        row.lockStatus
          ? getComponentUiText(
              "app-settings-organisation-manage-access-create-org-modal-locked-status-1",
            )
          : getComponentUiText(
              "app-settings-organisation-manage-access-create-org-modal-unlocked-status-1",
            )
      }</span> </span>`,
  },
  {
    text: getComponentUiText("app-component-custom-table-header-status-1"),
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    value: "status",
  },
  {
    text: "",
    value: "action",
    headerClass: "",
    valueClass: "tw-w-[45px] !tw-pr-[16px]",
  },
];

const orgsWithAccessToTableColumns: CustomTableColumn[] = [
  {
    text: getComponentUiText("app-component-custom-table-header-name-1"),
    value: "name",
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    render: (value: string) =>
      `<span class="tw-min-w-[180px] tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[normal]">${
        value.charAt(0).toUpperCase() + value.slice(1)
      }</span>`,
    sortable: true,
    sortDefault: true,
  },
  {
    text: getComponentUiText(
      "app-settings-organisation-manage-access-table-header-org-type-1",
    ),
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    render: (value: string) =>
      `<span class="!tw-w-[200px]"><span style="border:1px solid ${
        ORG_TO_ORG_TYPE_CORLOR[value]
          ? ORG_TO_ORG_TYPE_CORLOR[value].border
          : ORG_TO_ORG_TYPE_CORLOR.don.border
      } " class='tw-text-[${
        ORG_TO_ORG_TYPE_CORLOR[value]
          ? ORG_TO_ORG_TYPE_CORLOR[value].text
          : ORG_TO_ORG_TYPE_CORLOR.don.text
      }] tw-px-[5px] tw-py-[3px] tw-rounded-[4px] !tw-text-[11px] !tw-not-italic !tw-font-medium !tw-leading-[130%] ${
        value === "Beneficiary" ? "benefica-text" : ""
      }'>${getAccessType(value)}</span></span>`,
    value: "orgType",
  },
  {
    text: getComponentUiText(
      "app-settings-organisation-manage-access-table-header-org-owner-1",
    ),
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    value: "orgOwner",
    render: (value: any) =>
      `<span class="tw-flex tw-flex-col">
      <span class="tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-normal tw-leading-normal">${value.name}</span>
      <div class="box-email ${value.email.length > 40 ? 'long-email' : ''}">
      <div class="tooltip-arrow"></div>
      <div class="box-tooltip"> <span class="tw-text-[#211F58] tw-text-[11px] tw-not-italic tw-font-medium tw-leading-[100%]">${value.email}</span> </div>
      <div class="tw-text-[#878787] tw-text-xs tw-not-italic tw-font-normal tw-leading-[100%] tw-text-[12px] text-ellipsis" v-b-popover.focus.top="'I am popover directive content!'">${value.email}</div>
      </div>
      </span>`,
  },
  {
    text: getComponentUiText(
      "app-settings-organisation-manage-access-table-header-lock-status-1",
    ),
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    value: "*",
    render: (row: any) =>
      `<span class="tw-flex tw-items-center tw-gap-[5px] tw-w-[130px]"> ${
        row.lockStatus
          ? `<img class="tw-h-[14px] tw-w-[14px]" src=${
              row.disabled ? "/img/lock1_grey_icon.svg" : "/img/lock1_icon.svg"
            } alt="icon" />`
          : ""
      } <span class="${
        row.disabled ? "tw-text-[#B7B7B7]" : "tw-text-[#231F20]"
      } tw-text-[13px] tw-not-italic tw-font-normal tw-leading-[normal]">${
        row.lockStatus
          ? getComponentUiText(
              "app-settings-organisation-manage-access-create-org-modal-locked-status-1",
            )
          : getComponentUiText(
              "app-settings-organisation-manage-access-create-org-modal-unlocked-status-1",
            )
      }</span> </span>`,
  },
  {
    text: getComponentUiText("app-component-custom-table-header-status-1"),
    headerClass:
      "tw-text-[#878787] tw-text-[10px] tw-not-italic tw-font-semibold tw-leading-[100%] tw-tracking-[1px] tw-uppercase",
    value: "status",
  },
  {
    text: "",
    value: "action",
    headerClass: "",
    valueClass: "tw-w-[45px] !tw-pr-[16px]",
  },
];

const orgRelationshipOptions: Ref<IOrgAccessType[]> = computed(
  () => store.getters["Org/getOrgAccessType"],
);

const getAccessType = (id: string) => {
  if (!orgRelationshipOptions.value) {
    return "";
  }
  return (
    orgRelationshipOptions.value.find((item) => item.id === id)?.name || ""
  );
};

const isMenuPin = computed(
  () =>
    store.state.Navigation.chevronActive && store.state.Navigation.isMenuOpen,
);
onMounted(() => {
  setModal(history?.state?.modal);
  window.addEventListener("click", (e: any) => {
    if (!clickboxAccessRef.value?.contains(e.target)) {
      animationRef.value && animationRef.value?.reloadToggle();
    }
  });

  EventEmitter.on(
    EmitterEvents.APP_MODAL_MANAGE_ORGANISATIONS_VISIBILITY,
    (value: any) => {
      createdUserName.value = value;
    },
  );

  EventEmitter.on(EmitterEvents.REFRESH_ORG_DATA, (value: any) => {
    getFormData();
    updateAccessibleBySelectedRows([]);
    updateAccessToSelectedRows([]);
  });
  checkNavigate();
});

watch(history?.state?.modal, (state) => {
  setModal(state.modal as ModalTypes);
});

const fetchOrgAccessibleList = async () => {
  try {
    isLoadingOrgsWithAccessToTableData.value = true;
    const promises = [getOrgAccessGrantedByCurrent(), getAccessOffer()];
    const res: any = await Promise.all(promises);
    let arrayres: any = [];
    res.forEach((response) => {
      if (
        response?.data?.data &&
        (response.data.data.grantedOrgs || response.data.data.offers)
      ) {
        arrayres = arrayres.concat(
          response.data.data.grantedOrgs || response.data.data.offers,
        );
      }
    });
    orgsWithAccessToTableData.value = formatDataGrantedOrgs(arrayres, true);
  } catch (error: any) {
    isLoadingOrgsWithAccessToTableData.value = false;
    if (error && error.data) {
      showErrorAPI(error, Org.getAccessGrantedToCurrentOrg);
    }
  } finally {
    isLoadingOrgsWithAccessToTableData.value = false;
  }
};

//fetch org invalid domains
const getInvalidDomains = async () => {
  try {
    const invalidDomainsResponse = await fetchInvalidDomains();
    if (invalidDomainsResponse && invalidDomainsResponse.data) {
      store.dispatch(
        "Org/setOrgInvalidDomains",
        invalidDomainsResponse.data.data || [],
      );
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.getOrgDomainsInvalid);
    }
  }
};

//fetch org acces type
const fetchOrgAccessTypeByOrg = async () => {
  try {
    const orgToOrgTypeIdResponse = await fetchOrgAccessType();
    if (orgToOrgTypeIdResponse && orgToOrgTypeIdResponse.data) {
      store.dispatch(
        "Org/setOrgAccessType",
        orgToOrgTypeIdResponse.data.data || [],
      );
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.getOrgAccessTypes);
    }
  }
};

// fetch org access list by current org
const fetchOrgAccessList = async () => {
  try {
    isLoadingAccessibleByTableData.value = true;
    const promises = [getOrgAccessGrantedByOther(), getAccessRequest()];
    const res: any = await Promise.all(promises);
    let arrayres: any = [];
    res.forEach((response) => {
      if (
        response?.data?.data &&
        (response.data.data.grantedOrgs || response.data.data.requests)
      ) {
        arrayres = arrayres.concat(
          response.data.data.grantedOrgs || response.data.data.requests,
        );
      }
    });
    accessibleByTableData.value = formatDataGrantedOrgs(arrayres);
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.getAccessGrantedToCurrentOrg);
    }
  } finally {
    isLoadingAccessibleByTableData.value = false;
  }
};

const formatDataGrantedOrgs = (data: Array<any> = [], isAccessible = false) => {
  return data.map((org) => ({
    // get domain of requesteeEmail
    name:
      org.org2NameShort ||
      org.org1NameShort ||
      org.org1UserEmail?.match(/@([^.]+)\./)[1] ||
      org.org1UserEmail?.match(/@([^.]+)\./)[1] ||
      "",
    grantId: org.grantId || "",
    requestedBy: org.org1UserEmail || "",
    id: org.grantId || org.requestId || org.offerId,
    orgType: org.orgRelTypeId || org.orgToOrgTypeId || "",
    orgOwner: {
      name: utilities.getFullnamFromFirstAndLastName(
        isAccessible || !org.grantId
          ? org.org1UserFirstName || ""
          : org.org2UserFirstName || "",
        isAccessible || !org.grantId
          ? org.org1UserLastName || ""
          : org.org2UserLastName || "",
      ),
      email:
        isAccessible || !org.grantId
          ? org.org1UserEmail || ""
          : org.org2UserEmail || "",
    },
    lockStatus: org.orgRelTypeIsLocked || org.relTypeIsLocked,
    status: org.grantId ? statusCode.active : statusCode.pending,
    orgRelationshipType: org.orgToOrgTypeId,
    permLevelId: org.permLevelId,
  }));
};

const handleMultipleSelect = (_isAccessBy = false, dataSelected, dataTable) => {
  isMultipleSelect.value = true;
  isAssessBy.value = _isAccessBy;
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText(
        "app-settings-organisation-manage-access-remove-access-button-1",
      ),
      description: getComponentUiText(
        "app-settings-organisation-manage-access-remove-access-these-orgs-modal-helper-text-1",
      ),
      buttonText: getComponentUiText(
        "app-assessment-modal-remove-attachment-button-text-1",
      ),
      show: true,
      list: getNameListSelected(dataSelected, dataTable),
      buttonRed: true,
      updateDataFunction: async () => {
        await handleActionClick(actionClickType.actionRemoveOrgAccess);
      },
    },
    events: {
      "update:data": () =>
        handleActionClick(actionClickType.actionRemoveOrgAccess),
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const getNameListSelected = (data, dataTest) => {
  let result: any = [];
  data.forEach((item) =>
    dataTest.filter((itemTest) => {
      if (item === itemTest.id) {
        result.push(itemTest);
      }
    }),
  );
  return result.map((item) => item.name);
};

const handleActionClick = async (action: string) => {
  switch (action) {
    case actionClickType.actionRemoveOrgAccess:
      showModalRemoveOrgAccess.value = false;

      if (!isMultipleSelect.value) await removeAccessOrg();
      else await removeMultipleAccessOrg();

      isMultipleSelect.value = false;
      break;

    default:
  }
};

const handleManageUser = (value: any, action: string) => {
  if (!action) {
    return;
  }
  if (action === actionClickType.actionRemoveOrgAccess) {
    selectedSingleOrg.value = value;
    showModalRemoveOrgAccess.value = true;
    const emitData: IModalMessage = {
      component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
      properties: {
        value: {},
        title: getComponentUiText(
          "app-settings-team-members-profile-modal-remove-access-button-1",
        ),
        description: getComponentUiText(
          "app-settings-organisation-manage-access-remove-access-modal-helper-text-a-1",
        ),
        show: true,
        buttonRed: true,
        buttonText: getComponentUiText(
          "app-settings-team-members-profile-modal-remove-access-button-1",
        ),
        hiddenHelp: false,
        updateDataFunction: async () => {
          await handleActionClick(actionClickType.actionRemoveOrgAccess);
        },
      },
      events: {},
    };
    EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
    return;
  }
  showRejectOrAcceptModal(action, value);
};
const showRejectOrAcceptModal = (action: string, request) => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.ACCEPT_REJECT_REQUEST_ACCESS,
    properties: {
      action: action,
      requestDetail: request,
    },
    events: {
      "update:data": async () => {
        store.dispatch("Notification/getNotification", {
          includeActioned: true,
        });

        fetchOrgAccessibleList();
        fetchOrgAccessList();
      },
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

const removeAccessOrg = async () => {
  try {
    const payload = {
      grantIds: [parseInt(selectedSingleOrg.value.grantId)],
    };
    const res = await deleteAccessGrant(payload);
    if (res && res.data) {
      selectedSingleOrg.value = {};
      const emitData: IToastMessage = {
        variant: ToastVariant.SUCCESS,
        message: getComponentUiText(
          "app-settings-organisation-manage-access-remove-access-modal-toast-successfully-1",
        ),
      };
      EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
      getFormData();
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.getAccessGrants);
    }
  }
};

const removeMultipleAccessOrg = async () => {
  try {
    const grantIds = isAssessBy.value
      ? accessibleBySelectedRows.value
      : accessToSelectedRows.value;
    const res = await deleteOrgAccessGrants(grantIds);
    if (res && res.data) {
      const emitData: IToastMessage = {
        variant: ToastVariant.SUCCESS,
        message: getComponentUiText(
          "app-settings-organisation-manage-access-remove-access-modal-toast-successfully-1",
        ),
      };
      EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
      getFormData();
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.getAccessGrants);
    }
  }
};

const getFormData = async (initial = false) => {
  if (!initial)
    store.dispatch("Notification/getNotification", { includeActioned: true });
  await fetchOrgAccessibleList();
  await fetchOrgAccessList();
  await fetchOrgAccessTypeByOrg();
  await getInvalidDomains();
  if (isLoading.value) {
    EventEmitter.emit(EmitterEvents.PAGE_LOADING_COMPLETED);
  }
};

onBeforeMount(() => {
  getFormData(true);
});

const checkNavigate = () => {
  const route = useRoute();
  if (route.query.isOpenRequestModal) {
    router.replace(routers.settingOrgManageAccess);
    addRequestAccess();
  }

  if (route.query.isOpenCreateModal) {
    setModal(ModalTypes.CreateOrg);
  }

  EventEmitter.on(EmitterEvents.OPEN_REQUEST_MODAL, async () => {
    router.replace(routers.settingOrgManageAccess);
    addRequestAccess();
  });
};
onUnmounted(() => {
  EventEmitter.off(EmitterEvents.OPEN_REQUEST_MODAL);
  EventEmitter.off(EmitterEvents.REFRESH_ORG_DATA);
});

watch(
  () => currentOrg.value,
  (newValue, oldValue) => {
    if (newValue.id && oldValue.id && newValue.id !== oldValue.id) {
      getFormData();
      updateAccessibleBySelectedRows([]);
      updateAccessToSelectedRows([]);
    }
  },
  { deep: true },
);

const handleClickActionButton = (routerUrl: any) => {
  router.push(routerUrl);
};
const isShowMoreActions = ref(false);
const isShowMoreActionsOrg = ref(false);
const handleShowBulkAction = () => {
  isShowMoreActions.value = !isShowMoreActions.value;
  if (accessibleBySelectedRows.value.length < 1) {
    isShowMoreActions.value = false;
  }
};
const handleShowBulkActionOrg = () => {
  isShowMoreActionsOrg.value = !isShowMoreActionsOrg.value;
  if (accessToSelectedRows.value.length < 1) {
    isShowMoreActionsOrg.value = false;
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppBarLayout, null, {
      default: _withCtx(({ activeHierarchy }) => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(BrandPattern, {
            ref_key: "animationRef",
            ref: animationRef,
            page: "APPBARLAYOUT"
          }, null, 512),
          _createVNode(BackgroundComponent),
          _createVNode(ActivePathWrapper, { "active-hierarchy": activeHierarchy }, null, 8, ["active-hierarchy"]),
          _createElementVNode("div", {
            style: {"border-bottom":"1px solid #eff0f1"},
            class: _normalizeClass(`tw-flex tw-w-[100%] tw-flex-col tw-gap-[20px] title-wrapper tw-bg-[#ffffff] xl:tw-py-[55px] xl:tw-px-[60px] tw-px-[10px] tw-py-[10px] ${
            notInfoVisible.value ? '!tw-h-auto' : 'notifiMember'
          }`)
          }, [
            _createElementVNode("span", _hoisted_2, _toDisplayString(_unref(getComponentUiText)(
                "app-settings-organisation-manage-access-title-1",
              )), 1),
            (notInfoVisible.value)
              ? (_openBlock(), _createBlock(NoteInfo, {
                  key: 0,
                  onClose: _cache[0] || (_cache[0] = () => (notInfoVisible.value = false))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
                  "app-settings-organisation-manage-access-tip-top-text-1",
                )), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            id: "clickbox-access",
            ref_key: "clickboxAccessRef",
            ref: clickboxAccessRef,
            class: _normalizeClass(`tw-relative tw-z-[1] xl:tw-px-[60px] tw-px-[10px] md:tw-py-[55px] md:tw-px-[auto] tw-flex tw-gap-[20px] md:tw-gap-[50px] tw-flex-col ${
            isMenuPin.value ? 'access-container-pin' : 'access-container'
          }`)
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: _normalizeClass(`${
                isMenuPin.value ? 'table-container-pin' : 'table-container'
              } tw-flex tw-w-[100%] tw-gap-[60px] tw-flex-1 tw-order-[2] 2xl:tw-order-[1] forms`)
              }, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, [
                        _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                          "app-settings-organisation-manage-access-org-accessible-by-subtitle-1",
                        )) + " ", 1),
                        _createElementVNode("span", _hoisted_9, _toDisplayString(currentOrg.value.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", { onClick: handleShowBulkActionOrg }, [
                          _createVNode(ButtonBulkActions, {
                            active: accessToSelectedRows.value.length >= 1,
                            "id-popover": 'popover-btn-show-bulk-actions-org-manage-access',
                            class: _normalizeClass(`!tw-border tw-border-1 !tw-border-solid !tw-border-[#EFF0F1]`),
                            "show-more-actions": isShowMoreActionsOrg.value,
                            "show-acction-click": true,
                            "selected-number": accessToSelectedRows.value.length
                          }, {
                            default: _withCtx(() => [
                              _createVNode(CustomDropDownItem, {
                                style: 'danger',
                                "id-text": 'app-settings-organisation-manage-access-bulk-actions-modal-remove-access-1',
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (
                              handleMultipleSelect(
                                false,
                                accessToSelectedRows.value,
                                orgsWithAccessToTableData.value,
                              )
                            ))
                              })
                            ]),
                            _: 1
                          }, 8, ["active", "show-more-actions", "selected-number"])
                        ]),
                        _createVNode(ButtonFilter, {
                          active: false,
                          "id-popover": 'popover-button-filter-action-manage-access',
                          "is-margin-right": true
                        }),
                        _createVNode(IconButton, {
                          src: "/img/plus_icon.svg",
                          onClick: addOfferAccess
                        })
                      ])
                    ]),
                    _createVNode(CustomTable, {
                      columns: orgsWithAccessToTableColumns,
                      data: orgsWithAccessToTableData.value,
                      "empty-text": 
                      _unref(getComponentUiText)('app-component-custom-table-no-data-2')
                    ,
                      "is-loading": isLoadingOrgsWithAccessToTableData.value,
                      "is-standard-row": true,
                      "custom-class": "table-org-access ",
                      onUpdateSelectedRows: updateAccessToSelectedRows
                    }, {
                      "cell(status)": _withCtx((data) => [
                        _createVNode(StatusBadge, {
                          value: data.value,
                          "onUpdate:status": ($event: any) => (updateStatus(data.item))
                        }, null, 8, ["value", "onUpdate:status"])
                      ]),
                      "cell(action)": _withCtx((data) => [
                        _createVNode(CellTableAction, {
                          id: 'manage-access-orgs-with-access-' + data.idx,
                          value: data,
                          actions: getOfferActions(data.item),
                          onManageUser: handleManageUser
                        }, null, 8, ["id", "value", "actions"])
                      ]),
                      _: 1
                    }, 8, ["data", "empty-text", "is-loading"])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("span", _hoisted_13, [
                        _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                          "app-settings-organisation-manage-access-org-with-access-to-subtitle-1",
                        )) + " ", 1),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(currentOrg.value.name), 1)
                      ]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("div", { onClick: handleShowBulkAction }, [
                          _createVNode(ButtonBulkActions, {
                            active: accessibleBySelectedRows.value.length >= 1,
                            "id-popover": 'popover-btn-show-bulk-actions-manage-access',
                            class: _normalizeClass(`!tw-border tw-border-1 !tw-border-solid !tw-border-[#EFF0F1]`),
                            "show-more-actions": isShowMoreActions.value,
                            "show-acction-click": true,
                            "selected-number": accessibleBySelectedRows.value.length
                          }, {
                            default: _withCtx(() => [
                              _createVNode(CustomDropDownItem, {
                                style: 'danger',
                                "id-text": 'app-settings-organisation-manage-access-bulk-actions-modal-remove-access-1',
                                onClick: _cache[2] || (_cache[2] = ($event: any) => (
                              handleMultipleSelect(
                                true,
                                accessibleBySelectedRows.value,
                                accessibleByTableData.value,
                              )
                            ))
                              })
                            ]),
                            _: 1
                          }, 8, ["active", "show-more-actions", "selected-number"])
                        ]),
                        _createVNode(ButtonFilter, {
                          active: false,
                          "id-popover": 'popover-button-filter-action-org-manage-access',
                          "is-margin-right": true
                        }),
                        _createVNode(IconButton, {
                          src: "/img/plus_icon.svg",
                          onClick: addRequestAccess
                        })
                      ])
                    ]),
                    _createVNode(CustomTable, {
                      columns: accessibleByTableColumns,
                      data: accessibleByTableData.value,
                      "empty-text": 
                      _unref(getComponentUiText)('app-component-custom-table-no-data-1')
                    ,
                      "is-loading": isLoadingAccessibleByTableData.value,
                      "is-standard-row": true,
                      "custom-class": "table-org-access",
                      onUpdateSelectedRows: updateAccessibleBySelectedRows
                    }, {
                      "cell(status)": _withCtx((data) => [
                        _createVNode(StatusBadge, {
                          value: data.value
                        }, null, 8, ["value"])
                      ]),
                      "cell(action)": _withCtx((data) => [
                        _createVNode(CellTableAction, {
                          id: 'manage-access-org-accessible-' + data.idx,
                          value: data,
                          actions: getRequestActions(data.item),
                          onManageUser: handleManageUser
                        }, null, 8, ["id", "value", "actions"])
                      ]),
                      _: 1
                    }, 8, ["data", "empty-text", "is-loading"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(ActionButton, {
                    "profile-actions": profileActions,
                    class: "tw-max-w-[241px]"
                  })
                ])
              ], 2)
            ])
          ], 2)
        ])
      ]),
      _: 1
    }),
    _createVNode(Tooltip, {
      id: "invitation-sent-success-tooltip",
      variant: "success",
      show: showTooltip.value,
      onClose: _cache[3] || (_cache[3] = ($event: any) => (showTooltip.value = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_17, [
          _createVNode(_unref(VRuntimeTemplate), {
            template: 
          _unref(getComponentUiText)(
            'app-settings-organisation-manage-access-tooltip-text-1',
            false,
            { email: `<b>${email.value}</b>` },
          )
        
          }, null, 8, ["template"])
        ]),
        _createElementVNode("span", _hoisted_18, _toDisplayString(_unref(getComponentUiText)(
        "app-settings-organisation-manage-access-tooltip-text-2",
      )), 1)
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(Tooltip, {
      id: "org-created-success-tooltip",
      variant: "success",
      show: !!createdUserName.value,
      onClose: _cache[4] || (_cache[4] = ($event: any) => (createdUserName.value = null))
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_19, [
          _createVNode(_unref(VRuntimeTemplate), {
            template: 
          _unref(getComponentUiText)(
            'app-settings-organisation-manage-access-create-org-success-tooltip-text-1',
            false,
            {
              username: `<span class='tw-font-semibold'>${createdUserName.value}</span>`,
            },
          )
        
          }, null, 8, ["template"])
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(CreateOrgModal, {
      show: modal.value === _unref(ModalTypes).CreateOrg,
      type: _unref(requestAccessDetailModalType).createRequest,
      "onUpdate:show": setModal
    }, null, 8, ["show", "type"]),
    _createVNode(RequestAccessDetailModal, {
      show: showModalRequest.value,
      "onUpdate:show": _cache[5] || (_cache[5] = ($event: any) => (showModalRequest.value = $event))
    }, null, 8, ["show"]),
    _createVNode(OfferAccessModal, {
      show: showModalOffer.value,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => (showModalOffer.value = $event))
    }, null, 8, ["show"])
  ], 64))
}
}

})